"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconMap = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var React = __importStar(require("react"));

exports.IconMap = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return (0, jsx_runtime_1.jsxs)("svg", _objectSpread(_objectSpread({
    width: "39",
    height: "39",
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef,
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M32.807 5.34737V5.78482C32.807 6.02401 32.807 6.30173 32.7657 6.53933L37.9495 8.12861V11.3862L30.4165 19.9286C30.3359 20.0482 30.2553 20.1674 30.2553 20.2854V29.4238C28.9991 29.2251 27.745 29.1059 26.4888 29.067V18.6961C26.2863 18.7752 26.0838 18.8157 25.8814 18.8157C25.6789 18.8157 25.5177 18.7752 25.3152 18.6961V29.0265C23.776 28.9474 22.6024 28.5096 21.8318 27.6764C21.7099 27.5568 21.6293 27.4372 21.5074 27.2791L21.4665 27.2385C20.6975 26.0871 20.7785 24.735 20.7785 24.735V24.6949V16.0329C20.7785 15.8342 20.6975 15.6757 20.5347 15.5561C20.3735 15.4369 20.2103 15.398 20.0078 15.477L13.8115 17.1859V8.04756L18.9541 6.45828C18.9132 6.06096 18.9132 5.66364 18.9132 5.26632L13.2025 7.01373L0 3V34.8261L13.2025 38.8399L25.7975 34.9863L39 39V7.17385L32.807 5.34737ZM1.34203 4.6318L4.5404 5.6251L4.33793 14.6844L1.34203 13.7702V4.6318ZM1.34203 14.9621L7.37512 16.7906L4.6623 22.6713L1.34203 21.082V14.9621ZM1.34203 34.074V22.3936L7.78008 25.4931L4.13545 34.9497L1.34203 34.074ZM12.7615 37.5708L5.26973 35.3065L9.07555 25.4526C9.19744 25.1744 9.07554 24.8566 8.79248 24.737L5.71438 23.2673L8.50779 17.2284L12.8012 18.5396L12.8028 37.5704L12.7615 37.5708ZM12.7615 17.2268L8.34823 15.8764H8.30693L5.51352 15.0026L5.716 5.94335L12.7615 8.08848V17.2268ZM13.9351 37.5708V18.4589L19.6851 16.8697V24.737C19.6851 24.9357 19.6045 26.0871 20.171 27.2791C19.8875 27.3986 19.5636 27.5973 19.2392 27.9156C17.8218 29.3062 17.2553 32.207 17.5388 36.4579L13.9351 37.5708ZM25.3561 34.074L18.6743 36.1011C18.4309 31.2928 19.3627 29.4663 20.0111 28.7507C20.2941 28.4325 20.5776 28.3129 20.7801 28.2739C20.8607 28.3534 20.9016 28.4325 20.9826 28.5131C21.995 29.5855 23.4532 30.1815 25.3565 30.2605L25.3561 34.074ZM37.9495 37.5708L26.5301 34.074V30.2995C27.9065 30.3396 29.3648 30.4981 30.7822 30.7373C33.6979 31.2137 36.4103 31.9694 37.9908 32.4458V37.5704L37.9495 37.5708ZM37.9495 31.2137C36.4107 30.7759 34.0615 30.1008 31.4702 29.6646V20.5667L37.9495 13.1758V31.2137Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M25.1754 16.8077C25.2532 16.9608 25.4107 17 25.4885 17C25.5663 17 25.684 17 25.7618 16.8077C25.8017 16.7308 29.5538 9.53906 30.4135 7.88479C31.1955 6.30707 31.1955 4.57625 30.4135 3.00045C29.4361 1.11618 27.4813 0 25.4866 0C24.6648 0 23.805 0.192312 23.0231 0.576936C21.7325 1.23041 20.7551 2.34698 20.2863 3.73047C19.8176 5.11589 19.9353 6.61515 20.5596 7.84556L25.1754 16.8077ZM25.4885 2.34505C27.2479 2.34505 28.6558 3.73008 28.6558 5.46089C28.6558 7.1917 27.2479 8.57712 25.4885 8.57712C23.7292 8.57712 22.3209 7.1917 22.3209 5.46089C22.3209 3.73008 23.7687 2.34505 25.4885 2.34505Z",
      fill: color
    }, void 0)]
  }), void 0);
});